import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./Dashboard.css";
import { useAuth } from "./AuthContext";
import axios from "axios";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
const Dashboard = () => {
  const [academy, setAcademy] = useState("");
  const [court, setCourt] = useState("");
  const [startHour, setStartHour] = useState("");
  const [startMinute, setStartMinute] = useState("");
  const [endHour, setEndHour] = useState("");
  const [endMinute, setEndMinute] = useState("");
  const [academies, setAcademies] = useState([]);
  const [courts, setCourts] = useState([]);
  const [allData, setAllData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const API_BASE_URL = process.env.REACT_APP_API_ACADEMIES;
  const API_KEY = process.env.REACT_APP_API_KEY;
  const API_KEY2 = process.env.REACT_APP_API_KEYSUBMIT;
  useEffect(() => {
    const headers = {
      'x-api-key': API_KEY,
    };

    axios
      .get(API_BASE_URL, { headers })
      .then((response) => {
        const { academiesCourtsAndArenas } = response.data;
        setAllData(academiesCourtsAndArenas); // Store full response

        const academyOptions = academiesCourtsAndArenas.map((item) => ({
          value: item.academy_id,
          label: item.academy_name,
        }));

        setAcademies(academyOptions);
      })
      .catch((error) => {
        console.error("Error fetching academies and courts", error);
      });
  }, []);


  const handleAcademyChange = (selectedOption) => {
    setAcademy(selectedOption);
    setCourt(null); // Reset selected court

    const selectedAcademyData = allData.find(
      (item) => item.academy_id === selectedOption.value
    );

    if (selectedAcademyData) {
      const courtNames = selectedAcademyData.court_names.split(",");
      const courtIds = selectedAcademyData.court_ids.split(",");

      // Map court names to their respective court IDs
      const courtOptions = courtNames.map((court, index) => ({
        value: courtIds[index].trim(), // Store court ID as value
        label: court.trim(),
      }));
      setCourts(courtOptions);
    } else {
      setCourts([]); // Reset courts if no match found
    }
  };



  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();

  };

  const handleStartHourChange = (e) => {
    const selectedHour = parseInt(e.target.value);
    setStartHour(selectedHour);
    setEndHour(""); // Reset end hour
    setEndMinute(""); // Reset end minute
  };

  const handleStartMinuteChange = (e) => {
    const selectedMinute = parseInt(e.target.value);
    setStartMinute(selectedMinute);
    setEndMinute(""); // Reset end minute
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!academy || !court || startHour === "" || startMinute === "" || endHour === "" || endMinute === "") {
      Swal.fire({
        icon: 'warning',
        title: 'All fields are required!',
        toast: true,
        position: 'top-end',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }

    // Convert selectedDate to IST
    const istDate = new Date(selectedDate);
    istDate.setHours(istDate.getHours() + 5);
    istDate.setMinutes(istDate.getMinutes() + 30);
    const formattedDate = format(istDate, "yyyy-MM-dd");

    // Adjust start time for IST
    let startISTHour = startHour + 5;
    let startISTMinute = startMinute + 30;
    let startDateShift = 0; // Track if date should shift

    if (startISTMinute >= 60) {
      startISTHour += 1;
      startISTMinute -= 60;
    }
    if (startISTHour >= 24) {
      startISTHour -= 24;
      startDateShift = 1;
    }

    // Adjust end time for IST
    let endISTHour = endHour + 5;
    let endISTMinute = endMinute + 30;
    let endDateShift = 0;

    if (endISTMinute >= 60) {
      endISTHour += 1;
      endISTMinute -= 60;
    }
    if (endISTHour >= 24) {
      endISTHour -= 24;
      endDateShift = 1;
    }

    // Apply date shift
    const finalStartDate = new Date(selectedDate);
    finalStartDate.setDate(finalStartDate.getDate() + startDateShift);
    const finalEndDate = new Date(selectedDate);
    finalEndDate.setDate(finalEndDate.getDate() + endDateShift);

    const finalFormattedStartDate = format(finalStartDate, "yyyy-MM-dd");
    const finalFormattedEndDate = format(finalEndDate, "yyyy-MM-dd");

    // Construct final start and stop time
    const startTime = `${finalFormattedStartDate}T${String(startISTHour).padStart(2, "0")}:${String(startISTMinute).padStart(2, "0")}:00`;
    const stopTime = `${finalFormattedEndDate}T${String(endISTHour).padStart(2, "0")}:${String(endISTMinute).padStart(2, "0")}:00`;

    const requestData = {
      center: parseInt(academy.value, 10),
      court: parseInt(court.value, 10),
      start: startTime,
      stop: stopTime,
    };
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_ZINCO,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
          }
        }
      );

      const apiStatus = response.data.externalResponse?.response?.status;
      if (apiStatus === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Message sent successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to send message!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {

      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.response?.data?.message || 'Failed to send message!',
        toast: true,
        position: 'top-end',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  };


  const filteredEndHours = hours.filter(
    (hour) => hour >= (startHour !== "" ? startHour : 0)
  );

  return (
    <div>
      <nav className="navbar">
        <h2>Dashboard</h2>
        <button onClick={handleLogout} className="logoutButton">
          Logout
        </button>
      </nav>

      <div className="mainContent">
        <form onSubmit={handleSubmit}>
          <div className="dropdownContainer">
            <label htmlFor="academy">Academy:</label>
            <Select
              id="academy"
              value={academy}
              onChange={handleAcademyChange}
              options={academies}
              placeholder="Select Academy"
              className="dropdown"
            />
          </div>

          <div className="dropdownContainer">
            <label htmlFor="court">Court:</label>
            <Select
              id="court"
              value={court}
              onChange={(selectedOption) => setCourt(selectedOption)}
              options={courts}
              placeholder="Select Court"
              className="dropdown"
              isDisabled={!academy}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999, 
                }),
              }}
            />

          </div>
          <div className="datePickerContainer">
            <label htmlFor="datePicker">Select Date:</label>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="yyyy-MM-dd"
              className="datePicker"
              inline
              minDate={new Date()} // Prevents selecting past dates
            />
          </div>


          <div className="timeContainerStart">
            <label htmlFor="startTime" className="timeLabelStart">
              Start Time:
            </label>
            <div className="timeSelectorsStart">
              <select
                id="startHour"
                value={startHour}
                onChange={handleStartHourChange}
                className="timeDropdownStart"
              >
                <option value="">Hour</option>
                {hours.map((hour) => (
                  <option key={hour} value={hour}>
                    {hour < 10 ? `0${hour}` : hour}
                  </option>
                ))}
              </select>
              <select
                id="startMinute"
                value={startMinute}
                onChange={handleStartMinuteChange}
                className="timeDropdownStart"
              >
                <option value="">Minute</option>
                {minutes.map((minute) => (
                  <option key={minute} value={minute}>
                    {minute < 10 ? `0${minute}` : minute}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="timeContainerEnd">
            <label htmlFor="endTime" className="timeLabelEnd">
              End Time:
            </label>
            <div className="timeSelectorsEnd">
              <select
                id="endHour"
                value={endHour}
                onChange={(e) => setEndHour(parseInt(e.target.value))}
                className="timeDropdownEnd"
              >
                <option value="">Hour</option>
                {filteredEndHours.map((hour) => (
                  <option key={hour} value={hour}>
                    {hour < 10 ? `0${hour}` : hour}
                  </option>
                ))}
              </select>
              <select
                id="endMinute"
                value={endMinute}
                onChange={(e) => setEndMinute(parseInt(e.target.value))}
                className="timeDropdownEnd"
              >
                <option value="">Minute</option>
                {minutes.map((minute) => (
                  <option
                    key={minute}
                    value={minute}
                    disabled={
                      endHour === startHour && minute < startMinute ? true : false
                    }
                  >
                    {minute < 10 ? `0${minute}` : minute}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="submitButtonContainer">
            <button type="submit" className="submitButton">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Dashboard;
